import { useState } from 'react'
import { message as $message } from 'antd'
import { getDisplayLabelListAll, queryTileLabels } from '@/services/goods'

/*
 * 爆款专区商品标签 相关
 * */
export default function useFreshmanLabelList() {
    const [loading, setLoading] = useState(true)
    const [loadingTile, setLoadingTile] = useState(true)
    const [labelList, setLabelList] = useState([])
    const [labelListTile, setLabelListTile] = useState([])

    // 查询佣金规则信息
    const queryLabelList = async () => {
        try {
            const { success, message, data } = await getDisplayLabelListAll()
            if (success) {
                setLabelList(data)
                setLoading(false)
            } else {
                $message.error(message)
            }
        } catch (e) {
            console.error('catchError', e)
        }
    }

    // 查询佣金规则信息(平铺结构)
    const queryLabelListTile = async () => {
        try {
            const { success, message, data } = await queryTileLabels()
            if (success) {
                setLabelListTile(data)
                setLoadingTile(false)
            } else {
                $message.error(message)
            }
        } catch (e) {
            console.error('catchError', e)
        }
    }

    return {
        queryLabelList,
        queryLabelListTile,
        loading,
        loadingTile,
        labelList,
        labelListTile
    }
}
